module.exports = __webpack_public_path__ + "static/media/adminBurgerMob.226fc8b3.svg";